export const ModalType = {
  CANCEL: 'CANCEL',
  DETAIL: 'DETAIL',
}



// WEBPACK FOOTER //
// ./scripts/pages/order/ordersList/constants.js